module.exports = __webpack_public_path__ + "static/media/backrise-45.09c403c7.png";